(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lb-about-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    const targets = [...root.querySelectorAll('[data-lb-reveal]')];
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) { targets.forEach(el => el.classList.add('is-visible')); return; }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    targets.forEach(el => observer.observe(el));
  }
  document.querySelectorAll('[data-lb-about-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-about-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-about-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    const targets = [...root.querySelectorAll('[data-lb-about-reveal]')];
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) { targets.forEach(el => el.classList.add('is-visible')); return; }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    targets.forEach(el => observer.observe(el));
  }
  document.querySelectorAll('.lb-about-story').forEach(section => init(section.closest('.lb-scope')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-categories"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    const track = root.querySelector('[data-lb-category-track]');
    root.querySelector('[data-lb-category-prev]')?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }));
    root.querySelector('[data-lb-category-next]')?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }));
    root.querySelectorAll('[data-lb-filter-link]').forEach(link => link.addEventListener('click', event => {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('lb:filter', { detail: { filter: link.dataset.lbFilterLink } }));
      document.getElementById('lb-collection')?.scrollIntoView({ behavior: 'smooth' });
    }));
  }
  document.querySelectorAll('[data-lb-category-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-category-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-collection-color-filter"] && !Shopify.designMode) return;
  try {
    
(function(){
  const colorTerms={
    white:['wit','white','weiss','blanc','bianco','blanco','branco'],
    black:['zwart','black','schwarz','noir','nero','negro','preto'],
    pink:['roze','pink','rose','rosa','rosado','rosada'],
    gold:['goud','gold','golden','goldfarben','dore','oro','dorado','dourado'],
    grey:['grijs','grey','gray','grau','gris','grigio','cinza'],
  };
  const clean=raw=>(raw||'').toString().trim().toLowerCase().replace(/\u00df/g,'ss').normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,' ').trim();
  const normalize=raw=>{
    const key=clean(raw);
    if(!key)return '';
    for(const [canonical,terms] of Object.entries(colorTerms)){
      if(key===canonical||terms.some(term=>key===term||(` ${key} `).includes(` ${term} `)))return canonical;
    }
    return key;
  };
  function init(root){
    if(!root||root.dataset.lbInit)return;root.dataset.lbInit='true';
    const colors=[...root.querySelectorAll('[data-lb-color-option]')];
    colors.forEach(button=>button.addEventListener('click',()=>{colors.forEach(item=>item.classList.toggle('is-active',item===button));const raw=button.dataset.lbColorOption;document.dispatchEvent(new CustomEvent('lb:color-filter',{detail:{color:raw==='all'?'all':normalize(raw)}}));}));
    const colorGroup=root.querySelector('[data-lb-color-filter-group]');
    document.addEventListener('lb:color-availability',event=>{
      if(!colorGroup||event.detail.collectionHandle!==root.dataset.lbCollectionHandle)return;
      const available=new Set((event.detail.colors||[]).map(normalize));
      let visibleSpecific=0;
      colors.forEach(button=>{
        if(button.dataset.lbColorOption==='all')return;
        const show=available.has(normalize(button.dataset.lbColorOption));
        button.hidden=!show;
        if(show)visibleSpecific+=1;
      });
      colorGroup.hidden=Number(event.detail.productCount)<=1||visibleSpecific===0;
      const active=colors.find(button=>button.classList.contains('is-active'));
      if(active?.hidden)colors.find(button=>button.dataset.lbColorOption==='all')?.click();
    });
  }
  document.querySelectorAll('[data-lb-filter-picker]').forEach(init);document.addEventListener('shopify:section:load',event=>init(event.target.querySelector('[data-lb-filter-picker]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-collection-grid"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';

    let saved = new Set();
    try { saved = new Set(JSON.parse(localStorage.getItem('livingbright-saved') || '[]')); } catch (error) { saved = new Set(); }

    const toast = message => document.dispatchEvent(new CustomEvent('lb:toast', { detail: { message } }));
    const grid = root.querySelector('[data-lb-coll-card-grid]');
    const main = root.querySelector('[data-lb-coll-main]');
    const loading = root.querySelector('[data-lb-coll-loading]');
    const setLoading = isLoading => {
      main?.classList.toggle('is-loading', isLoading);
      main?.setAttribute('aria-busy', String(isLoading));
      if (loading) loading.hidden = !isLoading;
    };

    const updateSaveButtons = scope => {
      (scope || root).querySelectorAll('[data-lb-save]').forEach(button => {
        const on = saved.has(button.dataset.lbSave);
        button.setAttribute('aria-pressed', String(on));
        button.innerHTML = on ? '&#9829;' : '&#9825;';
      });
    };

    // All per-card interactivity lives here so it can be re-run on cards
    // fetched later from other pages, not just the ones present at load.
    const bindCardScope = scope => {
      scope.querySelectorAll('[data-lb-swipe-track]').forEach(track => {
        if (track.dataset.lbBound) return;
        track.dataset.lbBound = 'true';
        const media = track.closest('.lb-coll-card-media');
        const dotsWrap = media?.querySelector('[data-lb-swipe-dots]');
        const dots = dotsWrap ? [...dotsWrap.children] : [];
        const prevBtn = media?.querySelector('[data-lb-swipe-prev]');
        const nextBtn = media?.querySelector('[data-lb-swipe-next]');
        const slideCount = track.children.length;

        const updateUI = () => {
          const index = Math.round(track.scrollLeft / track.clientWidth);
          dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
          if (prevBtn) prevBtn.disabled = index <= 0;
          if (nextBtn) nextBtn.disabled = index >= slideCount - 1;
        };
        track.addEventListener('scroll', updateUI, { passive: true });
        prevBtn?.addEventListener('click', event => {
          event.preventDefault();
          track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
        });
        nextBtn?.addEventListener('click', event => {
          event.preventDefault();
          track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
        });
        updateUI();
      });

      scope.querySelectorAll('[data-lb-save]').forEach(button => {
        if (button.dataset.lbBound) return;
        button.dataset.lbBound = 'true';
        button.addEventListener('click', () => {
          const id = button.dataset.lbSave;
          if (saved.has(id)) saved.delete(id); else saved.add(id);
          localStorage.setItem('livingbright-saved', JSON.stringify([...saved]));
          updateSaveButtons();
          document.dispatchEvent(new CustomEvent('lb:saved-changed'));
          toast(saved.has(id) ? 'Saved to your edit.' : 'Removed from your edit.');
        });
      });
      updateSaveButtons(scope);

      scope.querySelectorAll('[data-lb-open-dialog]').forEach(button => {
        if (button.dataset.lbBound) return;
        button.dataset.lbBound = 'true';
        button.addEventListener('click', () => document.getElementById(button.dataset.lbOpenDialog)?.showModal());
      });
      scope.querySelectorAll('dialog').forEach(dialog => {
        if (dialog.dataset.lbBound) return;
        dialog.dataset.lbBound = 'true';
        dialog.querySelector('.lb-dialog-close')?.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      });

      scope.querySelectorAll('[data-lb-variant-select]').forEach(select => {
        if (select.dataset.lbBound) return;
        select.dataset.lbBound = 'true';
        select.addEventListener('change', () => {
          select.closest('.lb-quick-content').querySelector('[data-lb-variant-id]').value = select.value;
        });
      });

      scope.querySelectorAll('[data-lb-add-form]').forEach(form => {
        if (form.dataset.lbBound) return;
        form.dataset.lbBound = 'true';
        form.addEventListener('submit', async event => {
          event.preventDefault();
          const button = form.querySelector('button[type=submit]');
          const status = form.querySelector('.lb-add-status');
          button.disabled = true;
          status.textContent = form.dataset.addingLabel || '';
          try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
            if (!response.ok) throw new Error(form.dataset.errorLabel || '');
            status.textContent = form.dataset.addedLabel || '';
            toast(form.dataset.addedLabel || '');
            document.dispatchEvent(new CustomEvent('lb:cart:refresh'));
          } catch (error) {
            status.textContent = error.message;
          } finally {
            button.disabled = false;
          }
        });
      });
    };

    bindCardScope(root);

    // Fetch every other page of the collection (once) and merge the product
    // cards into the grid, so the colour filter can match products beyond
    // whatever page happened to be loaded first.
    let allPagesLoaded = false;
    let loadingPromise = null;
    const loadRemainingPages = () => {
      if (allPagesLoaded || !grid) return Promise.resolve();
      if (loadingPromise) return loadingPromise;
      const totalPages = parseInt(grid.dataset.totalPages || '1', 10);
      const currentPage = parseInt(grid.dataset.currentPage || '1', 10);
      const collectionUrl = grid.dataset.collectionUrl;
      const sortBy = grid.dataset.sortBy;
      const sectionId = grid.dataset.sectionId;
      if (totalPages <= 1 || !collectionUrl || !sectionId) {
        allPagesLoaded = true;
        return Promise.resolve();
      }
      const pagesToFetch = [];
      for (let p = 1; p <= totalPages; p += 1) {
        if (p !== currentPage) pagesToFetch.push(p);
      }
      loadingPromise = Promise.all(pagesToFetch.map(p => {
        const localizedCollectionUrl = window.location.pathname || collectionUrl;
        const url = new URL(localizedCollectionUrl, window.location.origin);
        const currentParams = new URLSearchParams(window.location.search);
        currentParams.forEach((value, key) => url.searchParams.append(key, value));
        url.searchParams.set('page', p);
        url.searchParams.set('sort_by', sortBy);
        url.searchParams.set('section_id', sectionId);
        return fetch(url.toString())
          .then(res => res.text())
          .then(html => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const fetchedGrid = doc.querySelector('[data-lb-coll-card-grid]');
            if (!fetchedGrid) return;
            [...fetchedGrid.children].forEach(node => {
              if (node.matches('[data-lb-coll-card]') || node.tagName === 'DIALOG') {
                if (node.matches('[data-lb-coll-card]')) {
                  node.dataset.lbFetchedPage = 'true';
                  node.hidden = true;
                }
                grid.appendChild(node);
              }
            });
          })
          .catch(() => {});
      })).then(() => {
        allPagesLoaded = true;
        bindCardScope(grid);
      });
      return loadingPromise;
    };

    // Colour filter: instant client-side filtering, no page reload.
    // Loads the rest of the collection in the background the first time a
    // specific colour (not "All") is chosen.
    // Canonical color keys keep translated metafields and translated Theme
    // Editor labels matched to the same products in every storefront locale.
    const COLOR_TERMS = {
      white: ['wit', 'white', 'weiss', 'blanc', 'bianco', 'blanco', 'branco'],
      black: ['zwart', 'black', 'schwarz', 'noir', 'nero', 'negro', 'preto'],
      pink: ['roze', 'pink', 'rose', 'rosa', 'rosado', 'rosada'],
      gold: ['goud', 'gold', 'golden', 'goldfarben', 'dore', 'oro', 'dorado', 'dourado'],
      grey: ['grijs', 'grey', 'gray', 'grau', 'gris', 'grigio', 'cinza'],
    };
    const cleanColorText = raw => (raw || '').toString().trim().toLowerCase()
      .replace(/\u00df/g, 'ss')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
    const normalizeColor = raw => {
      const key = cleanColorText(raw);
      if (!key) return '';
      for (const [canonical, terms] of Object.entries(COLOR_TERMS)) {
        if (key === canonical || terms.some(term => key === term || (` ${key} `).includes(` ${term} `))) return canonical;
      }
      return key;
    };
    const getCardColors = card => {
      const colors = new Set();
      (card.dataset.color || '').split(',').forEach(value => {
        const color = normalizeColor(value);
        if (color) colors.add(color);
      });
      const fallbackColor = normalizeColor(card.dataset.colorSource || '');
      if (fallbackColor && Object.prototype.hasOwnProperty.call(COLOR_TERMS, fallbackColor)) colors.add(fallbackColor);
      return [...colors];
    };
    const publishColorAvailability = () => {
      const cards = [...root.querySelectorAll('[data-lb-coll-card]')];
      const colors = new Set();
      cards.forEach(card => getCardColors(card).forEach(color => colors.add(color)));
      document.dispatchEvent(new CustomEvent('lb:color-availability', {
        detail: {
          collectionHandle: root.dataset.lbCollectionHandle,
          colors: [...colors],
          productCount: cards.length,
        },
      }));
    };
    let activeColor = 'all';
    let activeModel = 'all';
    const applyVisualFilters = () => {
      const cards = [...root.querySelectorAll('[data-lb-coll-card]')];
      const pagination = root.querySelector('.lb-coll__pagination');
      const customFilterActive = activeColor !== 'all' || activeModel !== 'all';
      let shown = 0;
      cards.forEach(card => {
        const cardColors = getCardColors(card);
        const cardModels = (card.dataset.model || '').split(',').map(value => value.trim().toLowerCase()).filter(Boolean);
        const colorMatches = activeColor === 'all' || cardColors.includes(activeColor);
        const modelMatches = activeModel === 'all' || cardModels.includes(activeModel);
        const belongsToLoadedPage = card.dataset.lbFetchedPage !== 'true';
        const shouldShow = customFilterActive ? colorMatches && modelMatches : belongsToLoadedPage;
        card.hidden = !shouldShow;
        if (shouldShow) shown += 1;
      });
      if (pagination) pagination.hidden = customFilterActive;
      const countEl = root.querySelector('.lb-coll__count');
      if (countEl) {
        const label = countEl.textContent.replace(/^\d+\s*/, '');
        countEl.textContent = `${shown} ${label}`;
      }
      if (grid) grid.classList.toggle('is-empty', shown === 0);
      if (shown === 0) toast('Geen spiegels gevonden voor deze combinatie.');
    };

    let colorFilterRun = 0;
    document.addEventListener('lb:color-filter', event => {
      activeColor = event.detail.color === 'all' ? 'all' : normalizeColor(event.detail.color);
      const run = ++colorFilterRun;
      setLoading(true);
      Promise.all([
        loadRemainingPages(),
        new Promise(resolve => window.setTimeout(resolve, 320)),
      ]).then(() => {
        if (run !== colorFilterRun) return;
        applyVisualFilters();
        publishColorAvailability();
        setLoading(false);
      }).catch(() => {
        if (run === colorFilterRun) setLoading(false);
      });
    });

    document.addEventListener('lb:model-filter', event => {
      activeModel = (event.detail.model || 'all').toLowerCase();
      loadRemainingPages().then(applyVisualFilters);
    });

    loadRemainingPages().then(publishColorAvailability);

    root.querySelector('[data-lb-sort-select]')?.addEventListener('change', event => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.href = url.toString();
    });

    // Checkbox-style filters (availability, type, etc.) apply instantly,
    // but only touch their own param — anything else already in the URL
    // (like an applied price range) is preserved rather than rebuilt.
    root.querySelectorAll('[data-lb-filter-input]').forEach(field => field.addEventListener('change', () => {
      const params = new URLSearchParams(window.location.search);
      if (field.checked) params.set(field.name, field.value); else params.delete(field.name);
      window.location.search = params.toString();
    }));

    // Price range only submits when Apply is clicked, so both min and max
    // can be filled in first instead of jumping to results after the first field.
    root.querySelector('[data-lb-price-apply]')?.addEventListener('click', () => {
      const params = new URLSearchParams(window.location.search);
      root.querySelectorAll('[data-lb-price-input]').forEach(field => {
        if (field.value !== '') params.set(field.name, field.value); else params.delete(field.name);
      });
      window.location.search = params.toString();
    });

    // Filter dropdowns: click a label to toggle its panel; only one open at a
    // time; clicking outside or pressing Escape closes whichever is open.
    root.querySelectorAll('[data-lb-filter-dd-toggle]').forEach(toggle => {
      toggle.addEventListener('click', event => {
        event.stopPropagation();
        const dd = toggle.closest('[data-lb-filter-dd]');
        const wasOpen = dd.classList.contains('is-open');
        root.querySelectorAll('[data-lb-filter-dd]').forEach(other => {
          other.classList.remove('is-open');
          other.querySelector('[data-lb-filter-dd-toggle]')?.setAttribute('aria-expanded', 'false');
        });
        if (!wasOpen) {
          dd.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
        }
      });
    });
    document.addEventListener('click', () => {
      root.querySelectorAll('[data-lb-filter-dd]').forEach(dd => {
        dd.classList.remove('is-open');
        dd.querySelector('[data-lb-filter-dd-toggle]')?.setAttribute('aria-expanded', 'false');
      });
    });
    root.querySelector('[data-lb-filterbar]')?.addEventListener('click', event => event.stopPropagation());
    document.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        root.querySelectorAll('[data-lb-filter-dd]').forEach(dd => dd.classList.remove('is-open'));
      }
    });
  }
  document.querySelectorAll('[data-lb-coll-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-coll-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';

    let saved = new Set();
    try { saved = new Set(JSON.parse(localStorage.getItem('livingbright-saved') || '[]')); } catch (error) { saved = new Set(); }

    const toast = message => document.dispatchEvent(new CustomEvent('lb:toast', { detail: { message } }));

    // Track which image is showing as the user swipes/scrolls each card's gallery
    root.querySelectorAll('[data-lb-swipe-track]').forEach(track => {
      const media = track.closest('.lb-coll-card-media');
      const dotsWrap = media?.querySelector('[data-lb-swipe-dots]');
      const dots = dotsWrap ? [...dotsWrap.children] : [];
      const previous = media?.querySelector('[data-lb-swipe-prev]');
      const next = media?.querySelector('[data-lb-swipe-next]');
      const updateMedia = () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        if (previous) previous.disabled = index <= 0;
        if (next) next.disabled = index >= track.children.length - 1;
      };
      track.addEventListener('scroll', updateMedia, { passive: true });
      previous?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }));
      next?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }));
      updateMedia();
    });

    const carouselUpdaters = new Map();
    root.querySelectorAll('[data-lb-product-carousel]').forEach(carousel => {
      const grid = carousel.querySelector('[data-lb-product-grid]');
      const controls = carousel.querySelector('[data-lb-carousel-controls]');
      if (!grid || !controls) return;
      const previous = controls.querySelector('[data-lb-carousel-prev]');
      const next = controls.querySelector('[data-lb-carousel-next]');
      const pagination = controls.querySelector('[data-lb-carousel-pagination]');
      let pageCount = 0;

      const updateCarousel = () => {
        const maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
        const hasOverflow = maxScroll > 2;
        controls.hidden = !hasOverflow;
        if (!hasOverflow) {
          if (pagination) pagination.replaceChildren();
          return;
        }

        const nextPageCount = Math.max(2, Math.ceil(grid.scrollWidth / Math.max(1, grid.clientWidth)));
        if (pagination && nextPageCount !== pageCount) {
          pagination.replaceChildren();
          for (let index = 0; index < nextPageCount; index += 1) {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.className = 'lb-product-carousel__dot';
            dot.setAttribute('aria-label', `${index + 1} / ${nextPageCount}`);
            dot.addEventListener('click', () => {
              const target = nextPageCount > 1 ? (maxScroll * index) / (nextPageCount - 1) : 0;
              grid.scrollTo({ left: target, behavior: 'smooth' });
            });
            pagination.append(dot);
          }
        }
        pageCount = nextPageCount;
        const currentPage = pageCount > 1 ? Math.round((grid.scrollLeft / maxScroll) * (pageCount - 1)) : 0;
        pagination?.querySelectorAll('.lb-product-carousel__dot').forEach((dot, index) => {
          dot.classList.toggle('is-active', index === currentPage);
          dot.setAttribute('aria-current', index === currentPage ? 'true' : 'false');
        });
        if (previous) previous.disabled = grid.scrollLeft <= 2;
        if (next) next.disabled = grid.scrollLeft >= maxScroll - 2;
      };

      const movePage = direction => {
        const maxScroll = Math.max(0, grid.scrollWidth - grid.clientWidth);
        if (!maxScroll || pageCount < 2) return;
        const currentPage = Math.round((grid.scrollLeft / maxScroll) * (pageCount - 1));
        const targetPage = Math.max(0, Math.min(pageCount - 1, currentPage + direction));
        grid.scrollTo({ left: (maxScroll * targetPage) / (pageCount - 1), behavior: 'smooth' });
      };

      previous?.addEventListener('click', () => movePage(-1));
      next?.addEventListener('click', () => movePage(1));
      grid.addEventListener('scroll', updateCarousel, { passive: true });
      if ('ResizeObserver' in window) new ResizeObserver(updateCarousel).observe(grid);
      carouselUpdaters.set(grid, updateCarousel);
      updateCarousel();
    });

    const updateSaveButtons = () => {
      root.querySelectorAll('[data-lb-save]').forEach(button => {
        const on = saved.has(button.dataset.lbSave);
        button.setAttribute('aria-pressed', String(on));
        button.innerHTML = on ? '&#9829;' : '&#9825;';
      });
    };

    const setFilter = filter => {
      root.querySelectorAll('[data-lb-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lbFilter === filter)));
      const grids = [...root.querySelectorAll('[data-lb-tab-grid]')];
      let shown = 0;
      grids.forEach(grid => {
        const isActive = grid.dataset.lbTabGrid === filter;
        grid.hidden = !isActive;
        const carousel = grid.closest('[data-lb-product-carousel]');
        if (carousel) carousel.hidden = !isActive;
        if (isActive) {
          if (grid.hasAttribute('data-lb-saved-grid')) {
            // The saved grid holds every product; only reveal the saved ones.
            grid.querySelectorAll('[data-lb-product]').forEach(card => {
              const isSaved = saved.has(card.dataset.productId);
              card.hidden = !isSaved;
              if (isSaved) shown += 1;
            });
          } else {
            shown += grid.querySelectorAll('[data-lb-product]').length;
          }
          requestAnimationFrame(() => carouselUpdaters.get(grid)?.());
        }
      });
      if (!shown && filter === 'saved') toast('Save a mirror to see it here.');
    };

    root.querySelectorAll('[data-lb-filter]').forEach(button => button.addEventListener('click', () => setFilter(button.dataset.lbFilter)));
    document.addEventListener('lb:filter', event => setFilter(event.detail.filter));

    root.querySelectorAll('[data-lb-open-dialog]').forEach(button => button.addEventListener('click', () => document.getElementById(button.dataset.lbOpenDialog)?.showModal()));
    root.querySelectorAll('dialog').forEach(dialog => {
      dialog.querySelector('.lb-dialog-close')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    });

    root.querySelectorAll('[data-lb-save]').forEach(button => button.addEventListener('click', () => {
      const id = button.dataset.lbSave;
      if (saved.has(id)) saved.delete(id); else saved.add(id);
      localStorage.setItem('livingbright-saved', JSON.stringify([...saved]));
      updateSaveButtons();
      document.dispatchEvent(new CustomEvent('lb:saved-changed'));
      toast(saved.has(id) ? 'Saved to your edit.' : 'Removed from your edit.');
    }));

    root.querySelectorAll('[data-lb-variant-select]').forEach(select => select.addEventListener('change', () => {
      select.closest('.lb-quick-content').querySelector('[data-lb-variant-id]').value = select.value;
    }));

    root.querySelectorAll('[data-lb-add-form]').forEach(form => form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('button[type=submit]');
      const status = form.querySelector('.lb-add-status');
      button.disabled = true;
      status.textContent = form.dataset.addingLabel || '';
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error(form.dataset.errorLabel || '');
        status.textContent = form.dataset.addedLabel || '';
        toast(form.dataset.addedLabel || '');
        document.dispatchEvent(new CustomEvent('lb:cart:refresh'));
      } catch (error) {
        status.textContent = error.message;
      } finally {
        button.disabled = false;
      }
    }));

    updateSaveButtons();

    const firstTabButton = root.querySelector('[data-lb-filter]');
    let defaultFilter = firstTabButton ? firstTabButton.dataset.lbFilter : 'all';
    // Safety net: if the default tab has no products configured yet
    // (merchant hasn't picked any), fall back to "All mirrors" instead of
    // showing an empty section.
    if (defaultFilter && defaultFilter !== 'all' && defaultFilter !== 'saved') {
      const grid = root.querySelector(`[data-lb-tab-grid="${defaultFilter}"]`);
      const hasAny = grid && grid.querySelectorAll('[data-lb-product]').length > 0;
      if (!hasAny) {
        const allButton = root.querySelector('[data-lb-filter="all"]');
        if (allButton) defaultFilter = 'all';
      }
    }
    const urlFilter = new URLSearchParams(window.location.search).get('filter');
    setFilter(urlFilter || defaultFilter);
  }
  document.querySelectorAll('[data-lb-collection-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-collection-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-contact-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    const targets = [...root.querySelectorAll('[data-lb-reveal]')];
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) {
      targets.forEach(el => el.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
    targets.forEach(el => observer.observe(el));
  }
  document.querySelectorAll('[data-lb-faq-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-faq-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-faqpage"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    const targets = [...root.querySelectorAll('[data-lb-reveal]')];
    if (!targets.length) return;
    if (!('IntersectionObserver' in window)) { targets.forEach(el => el.classList.add('is-visible')); return; }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    targets.forEach(el => observer.observe(el));
  }
  document.querySelectorAll('[data-lb-faqpage-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-faqpage-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-finish"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    const prefix = root.dataset.handlePrefix;
    root.querySelectorAll('[data-lb-finish]').forEach(button => button.addEventListener('click', () => {
      const name = button.dataset.lbFinish;
      root.querySelectorAll('[data-lb-finish]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      const imageWrap = root.querySelector('[data-lb-finish-image-wrap]');
      const image = imageWrap ? imageWrap.querySelector('img') : null;
      if (image && button.dataset.image) { image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = button.dataset.image; image.alt = button.dataset.label || name; }
      // The label comes from the section settings, so it follows the store language.
      const label = button.dataset.label || (name[0].toUpperCase() + name.slice(1));
      const nameEl = root.querySelector('[data-lb-finish-name]');
      if (nameEl) nameEl.textContent = label;
      const captionEl = root.querySelector('[data-lb-finish-caption]');
      if (captionEl) captionEl.textContent = label;
      // Without a handle prefix there is no product URL to build, so keep the
      // section's own link rather than sending shoppers to a missing page.
      const link = root.querySelector('[data-lb-finish-link]');
      if (link && button.dataset.url) {
        link.href = button.dataset.url;
      } else if (link && prefix) {
        const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        link.href = `${rootUrl}products/${prefix}${name}`;
      }
    }));
  }
  document.querySelectorAll('[data-lb-finish-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-finish-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-header"]) return;
  try {
    
(function () {
  if (window.__lbHeaderInit) return;
  window.__lbHeaderInit = true;

  const header = document.querySelector('[data-lb-header]');
  const menuToggle = document.querySelector('.lb-menu-toggle');
  const mobileNav = document.querySelector('.lb-mobile-nav');
  const mobileNavClose = document.querySelector('[data-lb-mobile-nav-close]');
  const mobileNavScrim = document.querySelector('[data-lb-mobile-nav-scrim]');
  const mobileOpenLabel = menuToggle?.getAttribute('aria-label') || 'Open menu';
  const mobileCloseLabel = mobileNavClose?.getAttribute('aria-label') || 'Close menu';
  const searchDialog = document.querySelector('[data-lb-search-dialog]');
  const cartDrawer = document.querySelector('[data-lb-cart-drawer]');
  const cartScrim = document.querySelector('[data-lb-cart-scrim]');
  const savedDrawer = document.querySelector('[data-lb-saved-drawer]');
  const savedScrim = document.querySelector('[data-lb-saved-scrim]');
  const toastEl = document.querySelector('[data-lb-toast]');
  let toastTimer;

  // Mobile menu
  const mobilePanels = [...(mobileNav?.querySelectorAll('[data-lb-mobile-panel]') || [])];
  let mobilePanelHistory = ['root'];
  const showMobilePanel = (name, forward = true) => {
    const current = mobilePanels.find(panel => panel.classList.contains('is-active'));
    const target = mobilePanels.find(panel => panel.dataset.lbMobilePanel === name);
    if (!target || target === current) return;
    current?.classList.remove('is-active');
    current?.classList.toggle('is-before', forward);
    target.classList.remove('is-before');
    target.classList.add('is-active');
    mobilePanels.forEach(panel => {
      const inactive = panel !== target;
      panel.setAttribute('aria-hidden', String(inactive));
      panel.inert = inactive;
    });
    target.scrollTop = 0;
    window.setTimeout(() => target.querySelector('[data-lb-mobile-panel-back],a,button')?.focus(), 310);
  };
  const resetMobilePanels = () => {
    mobilePanelHistory = ['root'];
    mobilePanels.forEach(panel => {
      const rootPanel = panel.dataset.lbMobilePanel === 'root';
      panel.classList.toggle('is-active', rootPanel);
      panel.classList.remove('is-before');
      panel.setAttribute('aria-hidden', String(!rootPanel));
      panel.inert = !rootPanel;
    });
  };
  const setMobileMenu = open => {
    mobileNav?.classList.toggle('is-open', open);
    mobileNavScrim?.classList.toggle('is-open', open);
    document.body.classList.toggle('lb-mobile-menu-open', open);
    menuToggle?.setAttribute('aria-expanded', String(open));
    menuToggle?.setAttribute('aria-label', open ? mobileCloseLabel : mobileOpenLabel);
    if (!open) window.setTimeout(resetMobilePanels, 320);
  };
  menuToggle?.addEventListener('click', () => setMobileMenu(!mobileNav?.classList.contains('is-open')));
  mobileNavClose?.addEventListener('click', () => setMobileMenu(false));
  mobileNavScrim?.addEventListener('click', () => setMobileMenu(false));
  mobileNav?.querySelectorAll('[data-lb-mobile-panel-open]').forEach(button => {
    button.addEventListener('click', () => {
      const target = button.dataset.lbMobilePanelOpen;
      mobilePanelHistory.push(target);
      showMobilePanel(target, true);
    });
  });
  mobileNav?.querySelectorAll('[data-lb-mobile-panel-back]').forEach(button => {
    button.addEventListener('click', () => {
      if (mobilePanelHistory.length > 1) mobilePanelHistory.pop();
      showMobilePanel(mobilePanelHistory[mobilePanelHistory.length - 1] || 'root', false);
    });
  });

  document.querySelectorAll('[data-lb-mega]').forEach(mega => {
    const trigger = mega.querySelector('[data-lb-mega-trigger]');
    const categories = [...mega.querySelectorAll('[data-lb-mega-category]')];
    const panels = [...mega.querySelectorAll('[data-lb-mega-panel]')];
    let closeTimer;
    const openMega = () => {
      window.clearTimeout(closeTimer);
      mega.classList.add('is-open');
      document.body.classList.add('lb-mega-open');
      trigger?.setAttribute('aria-expanded', 'true');
    };
    const closeMega = () => {
      window.clearTimeout(closeTimer);
      closeTimer = window.setTimeout(() => {
        mega.classList.remove('is-open');
        if (!document.querySelector('[data-lb-mega].is-open')) document.body.classList.remove('lb-mega-open');
        trigger?.setAttribute('aria-expanded', 'false');
      }, 280);
    };
    const activate = key => {
      categories.forEach(category => category.classList.toggle('is-active', category.dataset.lbMegaCategory === key));
      panels.forEach(panel => panel.classList.toggle('is-active', panel.dataset.lbMegaPanel === key));
    };
    categories.forEach(category => {
      category.addEventListener('pointerenter', () => activate(category.dataset.lbMegaCategory));
      category.addEventListener('focus', () => activate(category.dataset.lbMegaCategory));
    });
    mega.addEventListener('mouseenter', openMega);
    mega.addEventListener('mouseleave', closeMega);
    mega.addEventListener('focusin', openMega);
    mega.addEventListener('focusout', event => {
      if (!mega.contains(event.relatedTarget)) closeMega();
    });
    trigger?.addEventListener('click', event => {
      if (!window.matchMedia('(hover: none)').matches) return;
      if (!mega.classList.contains('is-open')) {
        event.preventDefault();
        mega.classList.add('is-open');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });
  });

  // Language switcher (desktop + mobile instances share the same markup pattern)
  document.querySelectorAll('[data-lb-locale-switcher]').forEach(switcher => {
    const toggle = switcher.querySelector('[data-lb-locale-toggle]');
    toggle?.addEventListener('click', event => {
      event.stopPropagation();
      const open = !switcher.classList.contains('is-open');
      document.querySelectorAll('[data-lb-locale-switcher]').forEach(s => {
        s.classList.remove('is-open');
        s.querySelector('[data-lb-locale-toggle]')?.setAttribute('aria-expanded', 'false');
      });
      if (open) {
        switcher.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });
  document.addEventListener('click', () => {
    document.querySelectorAll('[data-lb-locale-switcher]').forEach(s => {
      s.classList.remove('is-open');
      s.querySelector('[data-lb-locale-toggle]')?.setAttribute('aria-expanded', 'false');
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') {
      document.querySelectorAll('[data-lb-locale-switcher]').forEach(s => s.classList.remove('is-open'));
      document.querySelectorAll('[data-lb-mega]').forEach(mega => {
        mega.classList.remove('is-open');
        mega.querySelector('[data-lb-mega-trigger]')?.setAttribute('aria-expanded', 'false');
      });
      document.body.classList.remove('lb-mega-open');
      setMobileMenu(false);
      setSavedDrawer(false);
    }
  });

  mobileNav?.querySelectorAll('a').forEach(link => link.addEventListener('click', () => {
    setMobileMenu(false);
  }));

  // Search dialog
  document.querySelectorAll('.lb-search-open').forEach(button => button.addEventListener('click', () => {
    searchDialog?.showModal();
    searchDialog?.querySelector('input[type=search]')?.focus();
  }));
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.querySelector('.lb-dialog-close')?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
  });

  // Scroll progress bar on header bottom border
  const updateScrollProgress = () => {
    if (!header) return;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    const pct = max > 0 ? Math.min(100, Math.max(0, (scrollTop / max) * 100)) : 0;
    header.style.setProperty('--lb-scroll', pct + '%');
  };
  window.addEventListener('scroll', updateScrollProgress, { passive: true });
  window.addEventListener('resize', updateScrollProgress);
  updateScrollProgress();

  // Fixed/pinned header (bulletproof alternative to position:sticky)
  const spacer = document.querySelector('[data-lb-header-spacer]');
  const announcement = document.querySelector('[data-lb-announcement]');
  const updatePin = () => {
    if (!header) return;
    const annHeight = announcement ? announcement.offsetHeight : 0;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    if (scrollTop > annHeight) {
      if (!header.classList.contains('is-pinned')) {
        spacer.style.height = header.offsetHeight + 'px';
        spacer.classList.add('is-active');
        header.classList.add('is-pinned');
      }
    } else {
      header.classList.remove('is-pinned');
      spacer.classList.remove('is-active');
      spacer.style.height = '0';
    }
  };
  window.addEventListener('scroll', updatePin, { passive: true });
  window.addEventListener('resize', updatePin);
  updatePin();

  // Keep --header-group-height accurate for any sticky element on the page
  // (product gallery, how-it-works sticky media, etc. all offset from this).
  const updateHeaderHeightVar = () => {
    if (!header) return;
    document.documentElement.style.setProperty('--header-group-height', `${header.offsetHeight}px`);
    document.body.style.setProperty('--header-group-height', `${header.offsetHeight}px`);
  };
  window.addEventListener('resize', updateHeaderHeightVar);
  window.addEventListener('load', updateHeaderHeightVar);
  updateHeaderHeightVar();
  // Header height can change once webfonts finish loading
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(updateHeaderHeightVar);
  }

  // Toast (listened to from any section via a custom event)
  window.lbToast = message => {
    if (!toastEl) return;
    toastEl.textContent = message;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.classList.remove('is-visible'), 2200);
  };
  document.addEventListener('lb:toast', event => window.lbToast(event.detail?.message || ''));

  // Saved products drawer. The existing ID list stays authoritative; the
  // metadata cache lets the header render product details on every page.
  const readSavedIds = () => {
    try {
      const ids = JSON.parse(localStorage.getItem('livingbright-saved') || '[]');
      return Array.isArray(ids) ? ids.map(String) : [];
    } catch (error) { return []; }
  };
  const readSavedProducts = () => {
    try { return JSON.parse(localStorage.getItem('livingbright-saved-products') || '{}') || {}; }
    catch (error) { return {}; }
  };
  const escapeMarkup = value => String(value || '').replace(/[&<>'"]/g, char => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#39;', '"':'&quot;' }[char]));
  const safeUrl = value => {
    try {
      const url = new URL(value || '/', window.location.origin);
      return ['http:', 'https:'].includes(url.protocol) ? url.href : '#';
    } catch (error) { return '#'; }
  };
  const syncSavedProducts = ids => {
    const products = readSavedProducts();
    document.querySelectorAll('[data-lb-save]').forEach(button => {
      const id = String(button.dataset.lbSave || '');
      if (!ids.includes(id) || !button.dataset.lbSavedTitle) return;
      products[id] = {
        title: button.dataset.lbSavedTitle,
        url: button.dataset.lbSavedUrl,
        image: button.dataset.lbSavedImage,
        price: button.dataset.lbSavedPrice
      };
    });
    Object.keys(products).forEach(id => { if (!ids.includes(id)) delete products[id]; });
    localStorage.setItem('livingbright-saved-products', JSON.stringify(products));
    return products;
  };
  const renderSavedProducts = () => {
    if (!savedDrawer) return;
    const ids = readSavedIds();
    const products = syncSavedProducts(ids);
    const items = savedDrawer.querySelector('[data-lb-saved-items]');
    if (!items) return;
    if (!ids.length) {
      items.innerHTML = `<p class="lb-saved-empty">${escapeMarkup(savedDrawer.dataset.emptyLabel)}</p>`;
      return;
    }
    items.innerHTML = ids.map(id => {
      const product = products[id] || {};
      const title = product.title || savedDrawer.dataset.fallbackLabel;
      const url = product.url || savedDrawer.dataset.savedUrl;
      const media = product.image
        ? `<img src="${escapeMarkup(safeUrl(product.image))}" alt="${escapeMarkup(title)}" loading="lazy">`
        : '<span aria-hidden="true">&#9825;</span>';
      return `<article class="lb-saved-item" data-lb-saved-item="${escapeMarkup(id)}">
        <a class="lb-saved-item__image" href="${escapeMarkup(safeUrl(url))}">${media}</a>
        <div class="lb-saved-item__content">
          <a class="lb-saved-item__title" href="${escapeMarkup(safeUrl(url))}">${escapeMarkup(title)}</a>
          ${product.price ? `<span class="lb-saved-item__price">${escapeMarkup(product.price)}</span>` : ''}
          <div class="lb-saved-item__actions">
            <a class="lb-saved-item__view" href="${escapeMarkup(safeUrl(url))}">${escapeMarkup(savedDrawer.dataset.viewLabel)}</a>
            <button class="lb-saved-item__remove" type="button" data-lb-saved-remove>${escapeMarkup(savedDrawer.dataset.removeLabel)}</button>
          </div>
        </div>
      </article>`;
    }).join('');
  };
  const setSavedDrawer = open => {
    savedDrawer?.classList.toggle('is-open', open);
    savedScrim?.classList.toggle('is-open', open);
    savedDrawer?.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('lb-saved-drawer-open', open);
    document.querySelectorAll('[data-lb-saved-open]').forEach(button => button.setAttribute('aria-expanded', String(open)));
    if (open) renderSavedProducts();
  };
  const updateSavedCount = () => {
    const saved = readSavedIds();
    syncSavedProducts(saved);
    document.querySelectorAll('[data-lb-saved-count]').forEach(el => { el.textContent = saved.length || ''; });
  };
  document.querySelectorAll('[data-lb-saved-open]').forEach(button => button.addEventListener('click', event => {
    event.preventDefault();
    setSavedDrawer(true);
  }));
  document.querySelector('[data-lb-saved-close]')?.addEventListener('click', () => setSavedDrawer(false));
  savedScrim?.addEventListener('click', () => setSavedDrawer(false));
  savedDrawer?.addEventListener('click', event => {
    const remove = event.target.closest('[data-lb-saved-remove]');
    if (!remove) return;
    const item = remove.closest('[data-lb-saved-item]');
    const id = item?.dataset.lbSavedItem;
    if (!id) return;
    const sourceButton = [...document.querySelectorAll('[data-lb-save]')].find(button => String(button.dataset.lbSave) === id);
    if (sourceButton?.getAttribute('aria-pressed') === 'true') {
      sourceButton.click();
      return;
    }
    const saved = readSavedIds().filter(savedId => savedId !== id);
    localStorage.setItem('livingbright-saved', JSON.stringify(saved));
    document.querySelectorAll('[data-lb-save]').forEach(button => {
      if (String(button.dataset.lbSave) !== id) return;
      button.setAttribute('aria-pressed', 'false');
      button.innerHTML = '&#9825;';
    });
    document.dispatchEvent(new CustomEvent('lb:saved-changed'));
  });
  document.addEventListener('lb:saved-changed', () => {
    updateSavedCount();
    if (savedDrawer?.classList.contains('is-open')) renderSavedProducts();
  });
  updateSavedCount();

  // Cart drawer
  const money = (cents, cartCurrency) => {
    const drawer = document.querySelector('[data-lb-cart-drawer]');
    const currency = cartCurrency || drawer?.dataset.currency || 'EUR';
    const locale = drawer?.dataset.locale || document.documentElement.lang || 'nl';

    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
    } catch (error) {
      return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cents / 100);
    }
  };

  const renderCart = cart => {
    const itemsWrap = document.querySelector('[data-lb-cart-items]');
    const foot = document.querySelector('[data-lb-cart-foot]');
    const drawer = document.querySelector('[data-lb-cart-drawer]');
    const emptyLabel = drawer?.dataset.emptyLabel || '';
    const removeLabel = drawer?.dataset.removeLabel || '';
    const decreaseLabel = drawer?.dataset.decreaseLabel || '';
    const increaseLabel = drawer?.dataset.increaseLabel || '';
    if (!itemsWrap) return;
    document.querySelectorAll('[data-lb-cart-count]').forEach(el => { el.textContent = cart.item_count; });
    if (!cart.items.length) {
      itemsWrap.innerHTML = `<p class="lb-cart-empty">${emptyLabel}</p>`;
      if (foot) foot.hidden = true;
      return;
    }
    itemsWrap.innerHTML = cart.items.map(item => `
      <div class="lb-cart-item" data-key="${item.key}">
        <img src="${item.image ? item.image.replace('.jpg', '_150x.jpg') : ''}" alt="${item.product_title}" loading="lazy">
        <div>
          <div class="lb-cart-item-title">${item.product_title}</div>
          ${item.variant_title ? `<div class="lb-cart-item-variant">${item.variant_title}</div>` : ''}
          <div class="lb-cart-item-row">
            <div class="lb-cart-qty">
              <button type="button" data-lb-qty-down aria-label="${decreaseLabel}">&minus;</button>
              <span>${item.quantity}</span>
              <button type="button" data-lb-qty-up aria-label="${increaseLabel}">+</button>
            </div>
            <span class="lb-cart-item-price">${money(item.final_line_price, cart.currency)}</span>
          </div>
          <button type="button" class="lb-cart-remove" data-lb-remove>${removeLabel}</button>
        </div>
      </div>`).join('');
    if (foot) {
      foot.hidden = false;
      const subtotalEl = foot.querySelector('[data-lb-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = money(cart.total_price, cart.currency);
      if (window.KOSMApp && typeof window.KOSMApp.updatePurchaseAmount === 'function') {
        window.KOSMApp.updatePurchaseAmount(cart.total_price);
      }
    }
  };

  const fetchCart = () => fetch(window.Shopify.routes.root + 'cart.js').then(r => r.json());

  const changeLine = (key, quantity) => fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: key, quantity })
  }).then(r => r.json()).then(renderCart);

  const openCartDrawer = () => {
    cartDrawer?.classList.add('is-open');
    cartScrim?.classList.add('is-open');
    cartDrawer?.setAttribute('aria-hidden', 'false');
    fetchCart().then(renderCart).catch(() => {});
  };
  const closeCartDrawer = () => {
    cartDrawer?.classList.remove('is-open');
    cartScrim?.classList.remove('is-open');
    cartDrawer?.setAttribute('aria-hidden', 'true');
  };

  document.querySelector('[data-lb-cart-open]')?.addEventListener('click', event => {
    event.preventDefault();
    openCartDrawer();
  });
  document.querySelector('[data-lb-cart-close]')?.addEventListener('click', closeCartDrawer);
  cartScrim?.addEventListener('click', closeCartDrawer);

  document.addEventListener('click', event => {
    const item = event.target.closest('.lb-cart-item');
    if (!item) return;
    const key = item.dataset.key;
    if (event.target.matches('[data-lb-qty-up]')) {
      const qty = parseInt(item.querySelector('.lb-cart-qty span').textContent, 10) + 1;
      changeLine(key, qty);
    } else if (event.target.matches('[data-lb-qty-down]')) {
      const qty = Math.max(0, parseInt(item.querySelector('.lb-cart-qty span').textContent, 10) - 1);
      changeLine(key, qty);
    } else if (event.target.matches('[data-lb-remove]')) {
      changeLine(key, 0);
    }
  });

  // Refresh + auto-open drawer whenever a product is added elsewhere on the page
  document.addEventListener('lb:cart:refresh', () => {
    fetchCart().then(cart => { renderCart(cart); openCartDrawer(); });
  });

  fetchCart().then(renderCart).catch(() => {});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';

    // Desktop cross-fade slider
    const slides = [...root.querySelectorAll('.lb-hero-desktop-slides .lb-hero-image')];
    let active = 0;
    const show = index => {
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === active));
      const count = root.querySelector('[data-lb-hero-count]');
      if (count) count.textContent = `${String(active + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    };
    root.querySelector('[data-lb-hero-prev]')?.addEventListener('click', () => show(active - 1));
    root.querySelector('[data-lb-hero-next]')?.addEventListener('click', () => show(active + 1));

    // Mobile swipeable banner with dots
    const track = root.querySelector('[data-lb-hero-mobile-track]');
    const dots = root.querySelector('[data-lb-hero-mobile-dots]');
    if (track && dots && !dots.childElementCount) {
      const items = [...track.children];
      dots.hidden = items.length <= 1;
      if (!items.length) return;
      const step = () => items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
      const updateMobileHeading = index => {
        const showHeading = items[index]?.dataset.lbHeroMobileShowHeading !== 'false';
        root.classList.toggle('is-mobile-heading-hidden', !showHeading);
      };
      items.forEach((item, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `Show slide ${index + 1}`);
        dot.setAttribute('aria-pressed', String(index === 0));
        dot.addEventListener('click', () => track.scrollTo({ left: step() * index, behavior: 'smooth' }));
        dots.append(dot);
      });
      const updateDots = () => {
        const index = Math.min(Math.round(track.scrollLeft / step()), items.length - 1);
        [...dots.children].forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
        updateMobileHeading(index);
      };
      track.addEventListener('scroll', updateDots, { passive: true });
      updateMobileHeading(0);
    }
  }
  document.querySelectorAll('[data-lb-hero-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-hero-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-light"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    const imageWrap = root.querySelector('[data-lb-light-image-wrap]');
    const image = imageWrap ? imageWrap.querySelector('img') : null;
    const label = root.querySelector('[data-lb-light-label]');
    let copy = {};
    try { copy = JSON.parse(root.dataset.lbLightCopy || '{}'); } catch (error) { copy = {}; }
    root.querySelectorAll('[data-lb-light]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-lb-light]').forEach(item => item.setAttribute('aria-selected', String(item === button)));
      if (image) { image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.src = button.dataset.image; image.alt = `LivingBright mirror with ${button.dataset.lbLight} lighting`; }
      if (label) label.textContent = copy[button.dataset.lbLight][0];
    }));
    root.querySelector('[data-lb-brightness]')?.addEventListener('input', event => {
      if (image) image.style.filter = `brightness(${0.45 + Number(event.target.value) * 0.0055})`;
      event.target.nextElementSibling.value = `${event.target.value}%`;
    });
  }
  document.querySelectorAll('[data-lb-light-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-light-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-lookbook"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';
    const track = root.querySelector('[data-lb-lookbook-track]');
    const items = [...track.children];
    const step = () => items.length > 1 ? items[1].offsetLeft - items[0].offsetLeft : track.clientWidth;
    const move = direction => track.scrollBy({ left: step() * direction, behavior: 'smooth' });
    root.querySelector('[data-lb-gallery-prev]')?.addEventListener('click', () => move(-1));
    root.querySelector('[data-lb-gallery-next]')?.addEventListener('click', () => move(1));
    const dots = root.querySelector('[data-lb-gallery-dots]');
    items.forEach((item, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.setAttribute('aria-label', `Show gallery image ${index + 1}`);
      dot.addEventListener('click', () => track.scrollTo({ left: step() * index, behavior: 'smooth' }));
      dots.append(dot);
    });
    const update = () => {
      const index = Math.min(Math.round(track.scrollLeft / step()), items.length - 1);
      const visible = Math.max(1, Math.round(track.clientWidth / step()));
      const countEl = root.querySelector('[data-lb-gallery-count]');
      if (countEl) countEl.textContent = `${String(index + 1).padStart(2, '0')} - ${String(Math.min(index + visible, items.length)).padStart(2, '0')} / ${String(items.length).padStart(2, '0')}`;
      [...dots.children].forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === index)));
    };
    track.addEventListener('scroll', update, { passive: true });
    track.addEventListener('keydown', event => {
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
    });
    update();
  }
  document.querySelectorAll('[data-lb-lookbook-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-lookbook-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-search-results"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.lbInit) return;
    root.dataset.lbInit = 'true';

    let saved = new Set();
    try { saved = new Set(JSON.parse(localStorage.getItem('livingbright-saved') || '[]')); } catch (error) { saved = new Set(); }

    const toast = message => document.dispatchEvent(new CustomEvent('lb:toast', { detail: { message } }));

    root.querySelectorAll('[data-lb-swipe-track]').forEach(track => {
      const dotsWrap = track.closest('.lb-coll-card-media')?.querySelector('[data-lb-swipe-dots]');
      if (!dotsWrap) return;
      const dots = [...dotsWrap.children];
      track.addEventListener('scroll', () => {
        const index = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      }, { passive: true });
    });

    const updateSaveButtons = () => {
      root.querySelectorAll('[data-lb-save]').forEach(button => {
        const on = saved.has(button.dataset.lbSave);
        button.setAttribute('aria-pressed', String(on));
        button.innerHTML = on ? '&#9829;' : '&#9825;';
      });
    };

    root.querySelectorAll('[data-lb-save]').forEach(button => button.addEventListener('click', () => {
      const id = button.dataset.lbSave;
      if (saved.has(id)) saved.delete(id); else saved.add(id);
      localStorage.setItem('livingbright-saved', JSON.stringify([...saved]));
      updateSaveButtons();
      document.dispatchEvent(new CustomEvent('lb:saved-changed'));
      toast(saved.has(id) ? 'Saved to your edit.' : 'Removed from your edit.');
    }));
    updateSaveButtons();

    root.querySelectorAll('[data-lb-open-dialog]').forEach(button => button.addEventListener('click', () => document.getElementById(button.dataset.lbOpenDialog)?.showModal()));
    root.querySelectorAll('dialog').forEach(dialog => {
      dialog.querySelector('.lb-dialog-close')?.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    });

    root.querySelectorAll('[data-lb-variant-select]').forEach(select => select.addEventListener('change', () => {
      select.closest('.lb-quick-content').querySelector('[data-lb-variant-id]').value = select.value;
    }));

    root.querySelectorAll('[data-lb-add-form]').forEach(form => form.addEventListener('submit', async event => {
      event.preventDefault();
      const button = form.querySelector('button[type=submit]');
      const status = form.querySelector('.lb-add-status');
      button.disabled = true;
      status.textContent = form.dataset.addingLabel || '';
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) });
        if (!response.ok) throw new Error(form.dataset.errorLabel || '');
        status.textContent = form.dataset.addedLabel || '';
        toast(form.dataset.addedLabel || '');
        document.dispatchEvent(new CustomEvent('lb:cart:refresh'));
      } catch (error) {
        status.textContent = error.message;
      } finally {
        button.disabled = false;
      }
    }));
  }
  document.querySelectorAll('[data-lb-search-root]').forEach(init);
  document.addEventListener('shopify:section:load', e => init(e.target.querySelector('[data-lb-search-root]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-shapes"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(!root || root.dataset.lbShapeInit) return;
    root.dataset.lbShapeInit='true';
    const track=root.querySelector('[data-lb-shape-track]');
    const prev=root.querySelector('[data-lb-shape-prev]');
    const next=root.querySelector('[data-lb-shape-next]');
    if(!track || !next) return;
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const step=()=>{const card=track.querySelector('.lb-shape');if(!card)return track.clientWidth;const gap=parseFloat(getComputedStyle(track).columnGap)||0;return card.getBoundingClientRect().width+gap;};
    const max=()=>Math.max(0,track.scrollWidth-track.clientWidth);
    const go=direction=>{const atEnd=track.scrollLeft>=max()-8;const atStart=track.scrollLeft<=8;let left=track.scrollLeft+(direction*step());if(direction>0&&atEnd)left=0;if(direction<0&&atStart)left=max();track.scrollTo({left,behavior:reduced?'auto':'smooth'});};
    prev?.addEventListener('click',()=>go(-1));
    next.addEventListener('click',()=>go(1));
    let timer;
    const start=()=>{if(root.dataset.autoplay!=='true'||reduced)return;clearInterval(timer);timer=setInterval(()=>go(1),Math.max(2500,Number(root.dataset.delay)||4500));};
    const stop=()=>clearInterval(timer);
    root.addEventListener('mouseenter',stop);root.addEventListener('mouseleave',start);root.addEventListener('focusin',stop);root.addEventListener('focusout',start);root.addEventListener('touchstart',stop,{passive:true});root.addEventListener('touchend',start,{passive:true});
    start();
  }
  document.querySelectorAll('[data-lb-shape-carousel]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-lb-shape-carousel]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
